export const isRestaurantOpen = (currentOpeningHours) => {
    const now = new Date();
    let currentDay = now.getDay(); // Sunday - Saturday : 0 - 6
    let currentTime = now.getHours() * 60 + now.getMinutes(); // Convert current time to minutes
    if (!currentOpeningHours || currentOpeningHours.length === 0) return false;
    if (currentDay === 0) currentDay = 6; // Convert Sunday to 6 for indexing
    else currentDay -= 1; // Convert to 0-based index

    const openingHoursToday = currentOpeningHours[currentDay];
    let yesterday = currentDay - 1;
    if (yesterday === -1) yesterday = 6; // Convert Sunday to 6 for indexing
    const yesterdaysOpeningHours = currentOpeningHours[yesterday];

    if (openingHoursToday == null || yesterdaysOpeningHours == null) return false;

    const [, hours] = openingHoursToday.split(": ");
    const [, yesterdayHours] = yesterdaysOpeningHours.split(": ");

    if (hours == null) return false;

    if (hours.trim() === "Closed") return false;
    if (hours.trim() === "Open 24 hours") return true;

    const hoursOfOperation = hours.split(",");
    const splitRange = (segment) => {
        const s = segment.trim();
        if (s.includes("\u2013")) return s.split("\u2013");
        return s.split("-");
    };
    let [opening, closing] = splitRange(hoursOfOperation[0]);

    /** Google uses "11:00 AM – 8:00 PM"; normalize AM/PM and a.m./p.m. */
    const parseTime = (time) => {
        const raw = time.trim().replace(/\u202f|\u00a0/g, " ");
        const m = raw.match(/^(\d{1,2}):(\d{2})\s*(.*)$/);
        if (!m) return NaN;
        let hour = Number(m[1]);
        let min = Number(m[2]);
        const periodNorm = m[3]
            .trim()
            .toLowerCase()
            .replace(/\./g, "")
            .replace(/\s/g, "");
        let isPm = periodNorm === "pm" || periodNorm.startsWith("p");
        let isAm = periodNorm === "am" || periodNorm.startsWith("a");
        if (!periodNorm) {
            if (hour <= 5 || hour === 12) isPm = true;
            else isAm = true;
        }
        if (isPm && hour !== 12) hour += 12;
        if (isAm && hour === 12) hour = 0;
        return hour * 60 + min;
    };

    const isTimeBetween = (opening, closing) => {
        const openingMinutes = parseTime(opening);
        const closingMinutes = parseTime(closing);
        if (closingMinutes < openingMinutes) {
            return currentTime >= openingMinutes || currentTime < closingMinutes;
        } else {
            return currentTime >= openingMinutes && currentTime < closingMinutes;
        }
    };

    if (hoursOfOperation.length > 1) {
        for (let i = 0; i < hoursOfOperation.length; i++) {
            [opening, closing] = splitRange(hoursOfOperation[i]);
            if (opening && closing && isTimeBetween(opening, closing)) return true;
        }
    }

    const openingMinutes = parseTime(opening);
    const closingMinutes = parseTime(closing);

    if (yesterdayHours.trim() !== "Closed") {
        const yParts = yesterdayHours.includes("\u2013")
            ? yesterdayHours.split("\u2013")
            : yesterdayHours.split("-");
        const [, yesterdayClosing] = yParts;
        const [, yesterdayClosingperiod] = yesterdayClosing.trim().split(" ");
        const yesterdayClosingMinutes = parseTime(yesterdayClosing);
        if (currentTime < yesterdayClosingMinutes && yesterdayClosingperiod === "a.m.") {
            return true;
        }
    }

    if (closingMinutes < openingMinutes) {
        return currentTime >= openingMinutes || currentTime < closingMinutes;
    } else {
        return currentTime >= openingMinutes && currentTime < closingMinutes;
    }
};
